import { Component, ViewEncapsulation } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";

@Component({
  selector: "kzn-footer-create",
  standalone: true,
  imports: [TranslateModule],
  templateUrl: "./footer-create.component.html",
  styleUrl: "./footer-create.component.scss",
  encapsulation: ViewEncapsulation.None,
})
export class FooterCreateComponent {}
